import React from 'react';
import {
  BrowserRouter as Router,
  Route,
} from "react-router-dom";

import {  IntlProviderWrapper } from "./IntlContext";
import SurveySummary from './components/SurveySummary/SurveySummary';
import './App.css';

function App() {
  return (
    <Router>
      <Route path="/:language">
        {({match}) => 
            <IntlProviderWrapper languageUrl={match && match.params.language} >
              <Route path="/" component={SurveySummary} />
            </IntlProviderWrapper>
        }
      </Route>
    </Router>
  );
}

export default App;
